import { createEffect } from "effector";

import { getNewAccessToken } from "../api";

export const refreshSessionFx = createEffect(getNewAccessToken);
